import React, { useContext, useEffect, useState } from 'react';
import * as routes from '../constants/routes';
import SessionContext from './SessionContext';
import { withRouter } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap'
import { SvgTrashcan, SvgAdd } from '../assets/icons'
import * as EmailValidator from 'email-validator';
import Loading from './Loading';
import MixpanelContext from 'react-mixpanel';

function InvitationRow({email, onUpdateEmail, onDelete, onAdd }) {
  const isAddRow = !!onAdd

  const [value, setValue] = useState(email || '')

  const updateEmail = (e) => {
    setValue(e.target.value)
    if(onUpdateEmail) {
      onUpdateEmail(e.target.value)
    }
  }

  const addEmail = () => {
    if(!emailValid) return;
    onAdd(value)
    setValue('')
  }

  const emailValid = EmailValidator.validate(value)
  const iconStyle = { position: 'relative', top: -1}

  return (
    <div style={{display: 'flex', flexDirection: 'row', marginTop: 15}}>
      <input type="text" value={value} onChange={updateEmail} onBlur={addEmail} className="form-control" placeholder="john@example.com"/>
      { isAddRow ? <button type="button" onClick={addEmail} style={{visibility: (emailValid ? 'visible' : 'hidden') }} className="btn btn-icon btn-form-control"><SvgAdd style={iconStyle} /></button>
                 : <button type="button" onClick={onDelete} className="btn btn-icon btn-form-control"><SvgTrashcan style={iconStyle} /></button>}
    </div>
  )
}

export { InvitationRow }

function OnboardingPage({history}) {
  const sessionContext = useContext(SessionContext);
  const mixpanel = useContext(MixpanelContext);
  const [loading, setLoading] = useState(true)
  const [invitedHouseholds, setInvitedHouseholds] = useState([])
  const [creatingHousehold, setCreatingHousehold] = useState(true)
  const [invitationStep, setInvitationStep] = useState(false)
  const [householdName, setHouseholdName] = useState('')
  const [invitationEmails, setInvitationEmails] = useState([])
  const [submitting, setSubmitting] = useState(false)

  const fetchInvitations = async () => {
    try {
      // important to do this only after sessionContext.isLoading becomes false
      const client = sessionContext.getGraphqlClient()
      const query = `
        query InvitedHouseholds {
          myProfile {
            households {
              householdId
              title
              creator {
                given_name
                family_name
                picture
              }
            }
          }
        }
      `

      const request = {
        query,
        variables: null,
        operationName: 'InvitedHouseholds'
      };

      const resp = await client(request)
      const invitations = resp.data.myProfile.households;
      const isCreatingNewHousehold = invitations.length === 0
      setInvitedHouseholds(invitations)
      setCreatingHousehold(isCreatingNewHousehold)
      mixpanel.track('WFH_Create_House_Opened', { type: isCreatingNewHousehold ? 'create_new' : 'join' })
    } catch(e) {
      console.error(e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if(!sessionContext.isLoading) {
      if(!sessionContext.isAuthenticated) {
        history.push(routes.LANDING)
      } else if(sessionContext.household) {
        history.push(routes.SCHEDULES)
      } else {
        fetchInvitations()
      }
    }
  }, [sessionContext.isLoading])

  const householdNameValid = householdName.length > 4

  const nextStep = () => {
    if (householdNameValid) {
      setInvitationStep(true);
      mixpanel.track('WFH_Add_Member_Opened');
    }
  }

  const complete = async (emails) => {
    setSubmitting(true)
    const invites = emails.filter(email => EmailValidator.validate(email))
                          .map(email => `{ email: "${email}" }`)
    const client = sessionContext.getGraphqlClient()
    const query = `
      mutation CreateHousehold {
        updateHousehold(title: "${householdName}", invites: [${invites}]) {
          householdId
          title
          schedules {
            scheduleId
            title
          }
          members {
            given_name
            family_name
            picture
          }
        }
      }
    `
    const request = {
      query,
      variables: null,
      operationName: 'CreateHousehold'
    };

    try {
      const createResp = await client(request)

      sessionContext.setHousehold(createResp.data.updateHousehold)
      if(emails.length > 0) {
        mixpanel.track('WFH_Add_Member_Complete', { count: invites.length })
      } else {
        mixpanel.track('WFH_Add_Member_Skipped')
      }

      history.push(routes.SCHEDULES)
    } catch(e) {
      console.error(e)
    } finally {
      setSubmitting(false)
    }
  }

  const handleLogout = () => {
    sessionContext.logout()
    history.push(routes.LANDING)
  }

  const handleJoin = async (householdId) => {
    setSubmitting(true)
    const client = sessionContext.getGraphqlClient()
    const query = `
      mutation JoinHousehold {
        joinHousehold(householdId: "${householdId}") {
          householdId
          title
          schedules {
            scheduleId
            title
          }
          members {
            given_name
            family_name
            picture
          }
        }
      }
    `
    const request = {
      query,
      variables: { householdId },
      operationName: 'JoinHousehold'
    };

    try {
      const joinResp = await client(request)

      console.log('joinResp', joinResp)

      sessionContext.setHousehold(joinResp.data.joinHousehold)
      mixpanel.track('WFH_Create_House_Complete', { type: 'join' })
      history.push(routes.SCHEDULES)
    } catch(e) {
      console.error(e)
    } finally {
      setSubmitting(false)
    }
  }


  return (
    <Container style={{paddingLeft: '5%', paddingRight: '5%', height: '100%'}}>
      <Row>
        <Col xs={12} className="onboardingContainer">
          {loading && <Loading style={{marginTop: '5vh'}} />}
          {!loading && <>
            <h1>Hi, {sessionContext.user.given_name}!</h1>
            { !creatingHousehold && <>
              <p>It looks like you have already been invited to a household.</p>
              <p>You can only belong to one household - please select which one to join below (or create a new one).</p>
              { submitting && <Loading style={{marginTop: 30}} />}
              { !submitting && <div className="invitationWrapper">
                {invitedHouseholds.map((household, index) => {
                  const lastItem = invitedHouseholds.length - 1 === index;
                  return (<React.Fragment key={household.householdId}>
                    <div className="invitation">
                      <img src={household.creator.picture} className="avatar" />
                      <div className="invitationInfo">
                        <h2>{household.title}</h2>
                        <span>Created by {household.creator.given_name} {household.creator.family_name}</span>
                      </div>
                      <div style={{display: 'flex', alignItems: 'center'}}>
                        <button type="button" className="btn btn-primary btn-mini" onClick={() => handleJoin(household.householdId)}>
                          JOIN
                        </button>
                      </div>
                    </div>
                    {!lastItem && <div style={{height: 4, width: '100%', borderRadius: 2, backgroundColor: 'rgba(255,255,255,0.35)'}} />}
                  </React.Fragment>)
                })}
              </div>}
              { !submitting && <button
                type="button"
                className="btn btn-border"
                style={{ marginTop: 40, marginLeft: 'auto', marginRight: 'auto', display: 'block' }}
                onClick={() => {
                  setCreatingHousehold(true)
                  mixpanel.track('WFH_Create_House_Opened', { type: 'create_new' })
                }}>
                  I want to create my own household
                </button>}
            </>}
            { creatingHousehold && !invitationStep && <>
              <h3 style={{marginTop: 17}}>Let’s Build a Household</h3>
              <div className="createHousehold">
                <label>Household Name</label>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                  <input type="text" value={householdName} onChange={(e) => setHouseholdName(e.target.value)} className="form-control" placeholder="The Smiths"/>
                  <button type="button" onClick={nextStep} disabled={!householdNameValid} style={{width: 100}} className="btn btn-primary btn-form-control">NEXT</button>
                </div>
                { invitedHouseholds.length > 0 && <button
                  type="button"
                  className="btn btn-border"
                  style={{ marginTop: 40, marginLeft: 'auto', marginRight: 'auto', display: 'block' }}
                  onClick={() => {
                    setCreatingHousehold(false)
                    mixpanel.track('WFH_Create_House_Opened', { type: 'join' })
                  }}>
                    Someone already invited me to a household
                  </button>}
              </div>
            </>}
            { creatingHousehold && invitationStep && <>
              <h3 style={{marginTop: 9}}>Do you want to invite members to your household?</h3>
              <p style={{marginTop: 9}}>Inviting members allows family members and roommates to share schedules and tasks with each other.</p>
              <p style={{marginTop: 9}}>WFHScheduler requires a Google account to work, please make sure to send invites to Gmail addresses or companies using Google.</p>
              <div className="invitationStep">
                <label>Additional Household Members</label>
                { invitationEmails.map((email, index) => {
                  return (
                    <InvitationRow
                      key={index}
                      email={email}
                      onUpdateEmail={(value) => { invitationEmails[index] = value; setInvitationEmails(invitationEmails) }}
                      onDelete={() => setInvitationEmails(invitationEmails.filter((_, i) => i !== index))} />
                  )
                })}
                <InvitationRow onAdd={(email) => setInvitationEmails(invitationEmails.concat([email]))} />
                { submitting && <Loading style={{marginTop: 30}} />}
                { !submitting && <>
                  <div style={{padding: 10, marginTop: 20, display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                    <button type="button" className="btn btn-link" onClick={() => setInvitationStep(false)}>Back</button>
                    <button type="button" className="btn btn-link" onClick={() => complete([])}>Skip for now</button>
                  </div>
                  <div style={{padding: 10, marginTop: 20, display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                    <button type="button" className="btn btn-primary" onClick={() => complete(invitationEmails)}>Done</button>
                  </div>
                </>}
              </div>
            </>}
          </>}
        </Col>
      </Row>
      <Row>
        <Col align={'center'} >
          {!loading && <>
            <div>
              You're signed in as {sessionContext.user.email}. Not {sessionContext.user.given_name}?
              <button
                type="button"
                className="btn btn-border"
                onClick={handleLogout}
                style={{paddingLeft: 45, paddingRight: 45, display: 'block', marginTop: 15}}>
                  Logout
              </button>
            </div>
          </>}
        </Col>
      </Row>
    </Container>
  );
}

export default withRouter(OnboardingPage);
